import React from "react";
import { Folder, X } from "lucide-react";
import { INK, INK_2, INK_3, LINE, BURGUNDY, BURGUNDY_TINT } from "../../Bureau/bureauTokens";
import RoomsSettingsPanel from "./RoomsSettingsPanel";

// Chrome de modal (header icône+titre+croix, footer) autour de
// RoomsSettingsPanel.jsx — ouvert par le bouton "+" de la légende Salles
// pour un accès rapide, sans passer par les 5 onglets de
// PlanningSettingsModal.jsx (qui réutilise le même panel pour son onglet
// "Salles").
function RoomsManagerModal({ rooms, defaultCabinetId, onChange, onClose }) {
  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center p-4" style={{ background: "rgba(31,22,32,.45)" }} onClick={onClose}>
      <div
        className="w-full flex flex-col overflow-hidden"
        style={{ maxWidth: 520, maxHeight: "88vh", background: "#fff", borderRadius: 18, boxShadow: "0 24px 60px rgba(20,14,24,.30)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3.5 px-5 py-4 flex-shrink-0" style={{ borderBottom: `1px solid ${LINE}` }}>
          <div
            className="flex items-center justify-center flex-shrink-0"
            style={{ width: 40, height: 40, borderRadius: 10, background: BURGUNDY_TINT, color: BURGUNDY }}
          >
            <Folder size={19} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-semibold m-0" style={{ color: INK }}>
              Gérer les salles
            </h2>
            <div className="text-[11px] mt-0.5" style={{ color: INK_3 }}>
              Ajouter ou supprimer une salle de réunion
            </div>
          </div>
          <button onClick={onClose} className="flex items-center justify-center flex-shrink-0" style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${LINE}` }}>
            <X size={14} style={{ color: INK_2 }} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          <RoomsSettingsPanel rooms={rooms} defaultCabinetId={defaultCabinetId} onChange={onChange} />
        </div>

        <div className="flex items-center justify-end px-5 py-3.5 flex-shrink-0" style={{ borderTop: `1px solid ${LINE}`, background: "#FAFAF8" }}>
          <button onClick={onClose} className="px-4 py-2 text-xs" style={{ border: `1px solid ${LINE}`, borderRadius: 10, color: INK_2, background: "#fff" }}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}

export default RoomsManagerModal;
